import { AiOutlineFacebook } from "react-icons/ai";
import { AiOutlineInstagram } from "react-icons/ai";
import { AiOutlineDiscord } from "react-icons/ai";
import { AiFillGithub } from "react-icons/ai";

export const links = [
  { id: 1, link: "#", title: "Home" },
  { id: 2, link: "#about", title: "About" },
  { id: 3, link: "#services", title: "Services" },
  { id: 4, link: "#portfolio", title: "Portfolio" },
  { id: 5, link: "#contact", title: "Contact" },
];

export const socials = [
  {
    id: 1,
    link: "https://www.facebook.com/joshua.eerapogu",
    icon: <AiOutlineFacebook />,
  },
  {
    id: 2,
    link: "https://www.instagram.com/emmanueljoshua_ej/",
    icon: <AiOutlineInstagram />,
  },
  {
    id: 3,
    link: "https://discord.com/channels/@me",
    icon: <AiOutlineDiscord />,
  },
  { id: 4, link: "https://github.com/20R01A0470", icon: <AiFillGithub /> },
];
